<span class="sales-sqft-view" fxLayout="row" fxLayoutGap="5px">
  <span>{{value}} <span *ngIf="includeSuffix">/sqft</span></span>
  <span class="color-muted" *ngIf="value && includeSuffix">(<span>{{volumeSuffix}}</span>, <span>{{areaSuffix}}</span>)</span>
</span>
